<script lang="ts">
    import robot from '../assets/robot.avif';
    import { onMount } from 'svelte';
    import { useNavigate } from 'svelte-navigator';
    import { loadPresentationJson } from './loadPresentationJson';
    import Book from './Book.svelte';
    import type { Page } from './types';
    import BookPageContent from './BookPageContent.svelte';
    import { Button } from 'sveltestrap';

    export let id: string;

    const navigate = useNavigate();
    let pages: Array<Page> = [];
    let currentPage: number = -1;
    let isLastPage: boolean = false;

    function nextPage() {
        const nextPageIndex = currentPage + 1;
        if (nextPageIndex > pages.length - 1) {
            isLastPage = true;
            return;
        }
        setTimeout(() => {
            currentPage = nextPageIndex;
        }, 500);
    }

    function newStory() {
        navigate('/story/new');
    }

    function replay() {
        isLastPage = false;
        currentPage = -1;
        nextPage();
    }

    onMount(() => {
        if (!id) {
            navigate('/story');
            return;
        }
        loadPresentationJson(id).then(
            (result) => {
                currentPage = -1;
                pages = result.slides.map((page) => ({
                    lhs: { image: page.imagePath, text: page.headline },
                    rhs: { text: page.text },
                    audio: page.audioPath,
                }));
                nextPage();
            },
            (e) => {
                console.error(e);
                navigate('/story');
            }
        );
    });
</script>

{#if pages[currentPage]?.audio !== undefined}
    <audio src={pages[currentPage].audio} autoplay on:ended={nextPage} />
{/if}
<Book>
    <svelte:fragment slot="lhs">
        {#if pages[currentPage]?.lhs !== undefined}
            <BookPageContent {...pages[currentPage].lhs} />
        {:else}
            &nbsp;
        {/if}
    </svelte:fragment>
    <svelte:fragment slot="rhs">
        {#if pages[currentPage]?.rhs !== undefined}
            <BookPageContent {...pages[currentPage].rhs} />
        {:else}
            &nbsp;
        {/if}
        {#if isLastPage}
            <Button color="secondary" on:click={replay} size="lg">
                noch einmal anhören
            </Button>
            <Button color="primary" on:click={newStory} size="lg">
                eine neue Geschichte ausdenken
            </Button>
        {/if}
    </svelte:fragment>
</Book>
<div class="robot-wrapper">
    <img src={robot} alt="" class="reading-robot" />
</div>

<style>
    .robot-wrapper {
        position: fixed;
        bottom: 0;
        right: 0;
    }

    .reading-robot {
        height: 55svh;
        position: relative;
        left: 13svh;
    }
</style>
